/**
 * ASYCO Payment Selector — asyco-cart.js
 * Tema: DESARROLLO PRECIOS CRM
 *
 * Flujo:
 *  1. Carga instantánea desde window.ASYCO_CART_ITEMS (Liquid, sin fetch)
 *  2. /cart.js es la fuente de verdad de cantidades — se consulta en cada sync
 *  3. Polling cada 1.5 s detecta cambios de cantidad aunque el tema no dispare eventos
 *  4. MutationObserver y eventos del tema como capas adicionales de seguridad
 *  5. Guarda el método elegido como atributo del carrito para la Shopify Function
 *  6. Muestra barra de ahorro MP cuando el método elegido es mercadopago
 *  7. Actualiza el total de abajo según el método seleccionado
 */

(function () {
  'use strict';

  /* ─── Configuración ───────────────────────────────────────────────────────── */
  var CRM_ENDPOINT = 'https://asyco.com.co/crm/api/shopify/precios_contado.php';
  var POLL_INTERVAL = 1500; // ms entre cada chequeo de cambios en el carrito

  /* ─── Estado ──────────────────────────────────────────────────────────────── */
  var metodoSeleccionado = null;
  var preciosContado = {};  // { variantId: precioEnCentavosShopify }
  var cartItems = [];  // fuente de verdad — siempre de /cart.js
  var _debounceTimer = null;

  /* ─── Formateo COP ────────────────────────────────────────────────────────── */
  function formatMoney(centavos) {
    var pesos = Math.round(centavos / 100);
    return '$' + pesos.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  /* ─── ASYCO PROMO ADDI: porcentaje (0 = apagada; lo escribe el snippet Liquid) ─── */
  function addiPct() {
    var p = Number(window.ASYCO_ADDI_PCT || 0);
    return (p > 0 && p <= 100) ? p : 0;
  }
  function precioAddi(centavos) {
    return Math.round(centavos * (100 - addiPct()) / 100);
  }
  /* ASYCO PROMO ADDI MARCAS: la promo solo aplica a las marcas configuradas (lista vacía = todas) */
  function addiAplica(item) {
    var marcas = window.ASYCO_ADDI_MARCAS || [];
    if (!marcas.length) return true;
    var v = String(item.vendor || '').toLowerCase().replace(/\s+/g, '');
    return marcas.indexOf(v) !== -1;
  }

  /* ─── Total del carrito según método elegido ─────────────────────────────── */
  function calcularTotal(metodo) {
    return cartItems.reduce(function (total, item) {
      var precio = (metodo === 'mercadopago' && preciosContado[item.variant_id] != null)
        ? preciosContado[item.variant_id]
        : (metodo === 'addi' && addiPct() > 0 && addiAplica(item))
          ? precioAddi(item.price)
          : item.price;
      return total + precio * item.quantity;
    }, 0);
  }

  /* ─── Ahorro total al pagar con Addi (promo) ─────────────────────────────── */
  function calcularAhorroAddi() {
    if (addiPct() <= 0) return 0;
    return calcularTotalRegular() - calcularTotal('addi');
  }

  /* ─── Ahorro total al pagar con Mercado Pago (contado) ──────────────────── */
  function calcularAhorroMP() {
    return cartItems.reduce(function (ahorro, item) {
      if (preciosContado[item.variant_id] != null) {
        var diff = item.price - preciosContado[item.variant_id];
        if (diff > 0) ahorro += diff * item.quantity;
      }
      return ahorro;
    }, 0);
  }

  /* ─── Total "por defecto" (cuotas / precio regular de Shopify) ──────────── */
  function calcularTotalRegular() {
    return cartItems.reduce(function (total, item) {
      return total + item.price * item.quantity;
    }, 0);
  }

  /* ─── Actualizar botón CTA, total y barra de ahorro MP ─────────────────── */
  function actualizarUI() {
    var btn = document.getElementById('asyco-checkout-btn');
    var totalEl = document.getElementById('asyco-total-valor');
    var noticeMP = document.getElementById('asyco-notice-mp');
    var ahorroValorEl = document.getElementById('asyco-ahorro-mp-valor');

    // ASYCO 2 AI (CRO P1): si no hay método elegido, anclar el total al precio de CONTADO
    // (el más bajo) en vez del regular alto. Evita el sticker shock vs el precio del PDP.
    // No auto-commitea el método (la Shopify Function sigue ligada a la selección real).
    var totalMostrado = metodoSeleccionado
      ? calcularTotal(metodoSeleccionado)
      : calcularTotal('mercadopago');

    if (totalEl) {
      totalEl.textContent = formatMoney(totalMostrado) + ' COP';
    }

    // Barra de ahorro MP: solo visible cuando mercadopago está elegido Y hay ahorro real
    if (noticeMP) {
      var ahorro = calcularAhorroMP();
      if (metodoSeleccionado === 'mercadopago' && ahorro > 0) {
        if (ahorroValorEl) ahorroValorEl.textContent = formatMoney(ahorro);
        noticeMP.classList.add('visible');
      } else {
        noticeMP.classList.remove('visible');
      }
    }

    // ASYCO PROMO ADDI: aviso de ahorro solo con Addi elegido y promo encendida
    var noticeAddi = document.getElementById('asyco-notice-addi');
    if (noticeAddi) {
      var ahorroAddi = calcularAhorroAddi();
      if (metodoSeleccionado === 'addi' && ahorroAddi > 0) {
        var ahorroAddiEl = document.getElementById('asyco-ahorro-addi-valor');
        if (ahorroAddiEl) ahorroAddiEl.textContent = formatMoney(ahorroAddi);
        noticeAddi.classList.add('visible');
      } else {
        noticeAddi.classList.remove('visible');
      }
    }

    // Botón CTA
    if (!btn) return;
    if (!metodoSeleccionado) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.remove('activo');
      btn.textContent = 'Elige cómo pagar y continúa';
      return;
    }
    btn.disabled = false;
    btn.setAttribute('aria-disabled', 'false');
    btn.classList.add('activo');
    btn.textContent = 'Continuar con el pago';
  }

  /* ─── Guardar método en atributos del carrito ─────────────────────────────── */
  function guardarAtributoCarrito(metodo) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { metodo_pago_seleccionado: metodo } }),
    }).catch(function () { });
  }

  /* ─── Fallback CRM cuando el metafield no está en Liquid ────────────────── */
  function fetchPreciosCRM(skusNeeded) {
    fetch(CRM_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ skus: skusNeeded }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.success || !data.precios) return;
        cartItems.forEach(function (item) {
          if (item.sku && data.precios[item.sku] != null) {
            preciosContado[item.variant_id] = Math.round(data.precios[item.sku] * 100);
          }
        });
        actualizarUI();
      })
      .catch(function () { });
  }

  /* ─── Cargar precios contado desde ASYCO_CART_ITEMS ─────────────────────── */
  function cargarPrecios() {
    preciosContado = {};

    var liquidItems = window.ASYCO_CART_ITEMS || [];
    var liquidMap = {};
    liquidItems.forEach(function (item) {
      liquidMap[item.variant_id] = item;
      liquidMap[String(item.variant_id)] = item;
    });

    var skusNeeded = [];
    cartItems.forEach(function (item) {
      var li = liquidMap[item.variant_id] || liquidMap[String(item.variant_id)];
      if (li && li.precio_contado != null) {
        preciosContado[item.variant_id] = li.precio_contado;
      } else if (item.sku) {
        skusNeeded.push(item.sku);
      }
    });

    if (skusNeeded.length > 0) fetchPreciosCRM(skusNeeded);
  }

  /* ─── Restaurar estado visual de las opciones ────────────────────────────── */
  function restaurarSeleccion() {
    document.querySelectorAll('.asyco-opt').forEach(function (opt) {
      var activo = opt.dataset.metodo === metodoSeleccionado;
      opt.classList.toggle('seleccionado', activo);
      opt.setAttribute('aria-checked', activo ? 'true' : 'false');
    });
  }

  /* ─── Seleccionar método de pago ─────────────────────────────────────────── */
  function seleccionarOpcion(opt) {
    metodoSeleccionado = opt.dataset.metodo;
    restaurarSeleccion();
    guardarAtributoCarrito(metodoSeleccionado);
    actualizarUI();
  }

  /* ─── Sincronizar desde /cart.js (fuente de verdad) ─────────────────────── */
  function sincronizarCarrito() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartItems = cart.items;
          cargarPrecios();
          restaurarSeleccion();
          actualizarUI();
        })
        .catch(function () { });
    }, 80);
  }

  /* ─── Polling: detecta cambios de cantidad ─────────────────────────────── */
  function hashCarrito(items) {
    return items.length + ':' + items.map(function (i) {
      return i.variant_id + 'x' + i.quantity;
    }).join(',');
  }

  function iniciarPolling() {
    var hashActual = hashCarrito(cartItems);
    setInterval(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var nuevoHash = hashCarrito(cart.items);
          if (nuevoHash !== hashActual) {
            hashActual = nuevoHash;
            cartItems = cart.items;
            cargarPrecios();
            restaurarSeleccion();
            actualizarUI();
          }
        })
        .catch(function () { });
    }, POLL_INTERVAL);
  }

  /* ─── Event delegation — clic en opciones y botón checkout ──────────────── */
  function bindEventos() {
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('.asyco-opt');
      if (opt) {
        seleccionarOpcion(opt);
        return;
      }
      if (e.target.closest('#asyco-checkout-btn') && metodoSeleccionado) {
        window.location.href = '/checkout';
      }
    });

    // Accesibilidad teclado: Enter/Space activan la opción
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var opt = e.target.closest('.asyco-opt');
      if (opt) {
        e.preventDefault();
        seleccionarOpcion(opt);
      }
    });
  }

  /* ─── MutationObserver: re-renders completos del snippet ─────────────────── */
  function observarRerender() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.id === 'asyco-payment-selector' ||
            (n.querySelector && n.querySelector('#asyco-payment-selector'))) {
            sincronizarCarrito();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ─── Init ────────────────────────────────────────────────────────────────── */
  function init() {
    // 1. Carga instantánea desde Liquid
    var liquidItems = window.ASYCO_CART_ITEMS || [];
    if (liquidItems.length > 0) {
      cartItems = liquidItems;
      cargarPrecios();
      actualizarUI();
    }

    // 2+3. ASYCO 2 AI (perf): solo sincronizar y pollear /cart.js si el selector de pago
    // existe (estamos en la página de carrito). En PDP/home no hay selector → así evitamos
    // el polling cada 1.5s en TODAS las páginas (ahorra decenas de requests + batería).
    // El MutationObserver (observarRerender) dispara sincronizarCarrito si el selector
    // aparece luego (p.ej. al abrir el drawer del carrito).
    var _sel = document.getElementById('asyco-payment-selector');
    if (_sel && _sel.offsetParent !== null) {
      sincronizarCarrito();
      iniciarPolling();
    }

    // 4. Eventos del tema como capa extra
    document.addEventListener('cart:updated', sincronizarCarrito);
    document.addEventListener('on:cart:update', sincronizarCarrito);
    document.addEventListener('cart-drawer:open', sincronizarCarrito);
    document.addEventListener('cart:refresh', sincronizarCarrito);

    // 5. MutationObserver para re-renders del drawer
    observarRerender();
  }

  /* ─── Arranque ────────────────────────────────────────────────────────────── */
  bindEventos();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
